import {WindowParam} from "../../../library/context/WindowContext";
import {RowUnit} from "../../../library/atomic/unit/RowUnit";
import {SizeAttr} from "../../../library/basic/size";
import {ColumnUnit} from "../../../library/atomic/unit/ColumnUnit";
import {SpanText} from "../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../library/basic/font";
import {ColumnAttr, RowAttr} from "../../../library/basic/compose";
import {heightGap, widthGap} from "../../../library/atomic/unit/BoxUnit";
import knowMoreIcon from "../../../assets/official/office-home-know-more-icon.svg";
import downloadIcon from "../../../assets/official/office-home-download-icon.svg";
import {ImageUnit} from "../../../library/atomic/image/ImageUnit";
import {isSizeRangePhone} from "../compose/sizeRange";
import {downloadTrigger} from "../compose/officeLinkUtil";

export default function HomeInfoBox(wp: WindowParam, cusObj: {}, knowMoreClick: () => void, showBrowserHint: () => void) {
    return (
        <ColumnUnit
            fontAttr={new FontAttr(wp, "", "", "\"YouSheShaYuFeiTeJianKangTi\", \"YuanTi SC\"")}
            customStyleAttr={cusObj}>
            <SpanText
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {"letterSpacing": "2px"})}
                fontAttr={new FontAttr(wp, isSizeRangePhone(wp) ? "28px" : "46px")}>
                {"国风命理"}
            </SpanText>
            <SpanText
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                    "letterSpacing": "2px",
                    "marginTop": "8.5px"
                })}
                fontAttr={new FontAttr(wp, isSizeRangePhone(wp) ? "18px" : "26.5px")}>
                {"生辰八字、奇门遁甲、紫微斗数"}
            </SpanText>
            <SpanText
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                    "letterSpacing": "2px",
                    "marginTop": "18px",
                    "maxWidth": "520px"
                })}
                fontAttr={new FontAttr(wp, isSizeRangePhone(wp) ? "14px" : "18.5px")}>
                {"信风Flow App是一款由珠海煜明数字科技有限公司研发的国风命理App，能够帮助您推演命理信息、解读签文。"}
            </SpanText>
        </ColumnUnit>
    )
}

export function HomeInfoButton(wp: WindowParam, icon: string, text: string, onClick: () => void,
                               width: string = "168px", backgroundColor: string = "white") {
    return (
        <RowUnit
            needHover={true}
            customStyleAttr={{
                "borderRadius": "19px",
                "border": "1px solid black",
                "backgroundColor": backgroundColor,
                "boxShadow": "0 3px 2px rgba(0, 0, 0, 0.25)"
            }}
            fontAttr={new FontAttr(wp, "18.5px", "500", "\"Helvetica Neue\"")}
            sizeAttr={new SizeAttr(wp, width, "38px")}
            onClick={() => {
                onClick()
            }}
        >
            <ImageUnit
                url={icon}
                sizeAttr={new SizeAttr(wp, "18px")}
                customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                    "marginLeft": "22px",
                    "marginRight": "18px"
                })}
            />
            <SpanText customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                "marginRight": "auto",
                "letterSpacing": "0.6px",
            })}>
                {text}
            </SpanText>
        </RowUnit>
    )
}